import { Panel, useReactFlow, useViewport } from '@xyflow/react'
import { Maximize2, Minus, Plus } from 'lucide-react'
import { useTranslation } from 'react-i18next'

import { Button } from '@/shared/components/ui/button'

export function CanvasViewportControls() {
  const { t } = useTranslation()
  const rf = useReactFlow()
  const { zoom } = useViewport()

  return (
    <Panel position="bottom-left" className="studio-canvas-viewport">
      <div className="studio-canvas-viewport__group" title={t('canvas.viewport.selectionHint')}>
        <Button
          type="button"
          variant="ghost"
          size="icon-sm"
          className="studio-canvas-viewport__btn"
          onClick={() => rf.zoomIn({ duration: 200 })}
          aria-label={t('canvas.viewport.zoomIn')}
        >
          <Plus className="h-4 w-4" strokeWidth={2.25} />
        </Button>
        <span className="studio-canvas-viewport__sep" aria-hidden />
        <Button
          type="button"
          variant="ghost"
          size="sm"
          className="studio-canvas-viewport__pct h-auto px-2"
          onClick={() => rf.zoomTo(1, { duration: 200 })}
          title={t('canvas.viewport.resetZoom')}
        >
          {Math.round(zoom * 100)}%
        </Button>
        <span className="studio-canvas-viewport__sep" aria-hidden />
        <Button
          type="button"
          variant="ghost"
          size="icon-sm"
          className="studio-canvas-viewport__btn"
          onClick={() => rf.zoomOut({ duration: 200 })}
          aria-label={t('canvas.viewport.zoomOut')}
        >
          <Minus className="h-4 w-4" strokeWidth={2.25} />
        </Button>
        <span className="studio-canvas-viewport__sep" aria-hidden />
        <Button
          type="button"
          variant="ghost"
          size="icon-sm"
          className="studio-canvas-viewport__btn"
          onClick={() => rf.fitView({ duration: 280, padding: 0.18 })}
          aria-label={t('canvas.viewport.fitView')}
        >
          <Maximize2 className="h-3.5 w-3.5" strokeWidth={2.25} />
        </Button>
      </div>
    </Panel>
  )
}
